import * as t from 'io-ts';

export const BaseEntityNullableType = t.interface({
    id: t.union([t.string, t.null, t.undefined]),
    name: t.union([t.string, t.null, t.undefined]),
});

export interface BaseEntityNullableDTO extends t.TypeOf<typeof BaseEntityNullableType> {
}

export class BaseEntityNullable {
    id: string | null;
    name: string | null;

    constructor(params: BaseEntityNullableDTO) {
        this.id   = params.id ?? null;
        this.name = params.name ?? null;
    }
}
